// Thêm nhanh của chế độ Kế toán (đợt 5, TQ-04): nút "+" trên header (kit AntMainHeader/AntQuickCreateMenu).
// Mỗi mục = đúng nút Thêm (isQuickCreate) của danh sách gốc: điều kiện hiện = whenUserScreen của danh sách + nguyên
// `visible` của nút Thêm; bấm = POST /<module>/<Table>/create rồi mở trang chi tiết. Không import gì (chạy được bằng
// node --test, bộ quét quyền đọc được). Nhãn dùng lại khối text của mục thực đơn cùng đích.

export const accountingQuickCreateGroups = [
    { key: 'voucher', text: { vi: 'Chứng từ', en: 'Vouchers', fr: 'Pièces', es: 'Comprobantes', id: 'Voucher', ja: '伝票', zh: '凭证', ko: '전표', hi: 'वाउचर', ar: 'القسائم' } },
    { key: 'catalog', text: { vi: 'Danh mục', en: 'Catalogs', fr: 'Catalogues', es: 'Catálogos', id: 'Katalog', ja: 'マスタ', zh: '基础资料', ko: '기초정보', hi: 'सूचियाँ', ar: 'القوائم' } }
];

const accountingQuickCreate = [
    {
        key: 'ca_receive',
        group: 'voucher',
        text: { vi: 'Thu tiền', en: 'Receipts', fr: 'Recettes', es: 'Cobros', id: 'Penerimaan', ja: '入金', zh: '收款', ko: '입금', hi: 'प्राप्तियाँ', ar: 'المقبوضات' },
        // pages/ca/CAReceives/index.js
        visible: { whenUserScreen: 'CAReceives', whenUser: { create_CAReceive: 1 }, whenSys: { use_Module_GL: 1 } },
        open: { module: 'ca', table: 'CAReceive', navigateLink: '/ca/CAReceive/' }
    },
    {
        key: 'ca_issue',
        group: 'voucher',
        text: { vi: 'Chi tiền', en: 'Payments', fr: 'Dépenses', es: 'Pagos', id: 'Pembayaran', ja: '出金', zh: '付款', ko: '출금', hi: 'भुगतान', ar: 'المدفوعات' },
        // pages/ca/CAIssues/index.js
        visible: { whenUserScreen: 'CAIssues', whenUser: { create_CAIssue: 1 }, whenSys: { use_Module_GL: 1 } },
        open: { module: 'ca', table: 'CAIssue', navigateLink: '/ca/CAIssue/' }
    },
    {
        key: 'exp_general',
        group: 'voucher',
        text: { vi: 'Chi phí', en: 'Expenses', fr: 'Charges', es: 'Gastos', id: 'Beban', ja: '経費', zh: '费用', ko: '비용', hi: 'व्यय', ar: 'المصروفات' },
        // pages/exp/EXPGeneralOrders/index.js
        visible: { whenUserScreen: 'EXPGeneralOrders', whenUser: { EXPOrder_can_create: 1 } },
        open: { module: 'exp', table: 'EXPGeneralOrder', navigateLink: '/exp/EXPOrder/' }
    },
    {
        key: 'exr_other',
        group: 'voucher',
        text: { vi: 'Phải thu khác', en: 'Other receivables', fr: 'Autres créances', es: 'Otras cuentas por cobrar', id: 'Piutang lain', ja: 'その他未収金', zh: '其他应收', ko: '기타 미수금', hi: 'अन्य प्राप्य', ar: 'ذمم أخرى' },
        // pages/exr/EXROtherOrders/index.js (base = use_Module_AR ? '/exr' : '/sale')
        visible: { whenUserScreen: 'EXROtherOrders', whenUser: { EXROrder_can_create: 1 } },
        open: { module: 'exr', table: 'EXROtherOrder', navigateLinkBySys: { use_Module_AR: ['/exr/EXROtherOrder/', '/sale/EXROtherOrder/'] } }
    },
    {
        key: 'gl_journal',
        group: 'voucher',
        text: { vi: 'Phiếu kế toán', en: 'Journal Voucher', fr: 'Pièce comptable', es: 'Comprobante diario', id: 'Voucher jurnal', ja: '仕訳伝票', zh: '记账凭证', ko: '분개 전표', hi: 'जर्नल वाउचर', ar: 'قسيمة اليومية' },
        // pages/gl/GLJournals/index.js
        visible: { whenUserScreen: 'GLJournals', whenUser: { GL_create_Journal: 1 } },
        open: { module: 'gl', table: 'GLJournal', navigateLink: '/gl/GLJournal/' }
    },
    {
        key: 'customer',
        group: 'catalog',
        text: { vi: 'Khách hàng', en: 'Customers', fr: 'Clients', es: 'Clientes', id: 'Pelanggan', ja: '顧客', zh: '客户', ko: '고객', hi: 'ग्राहक', ar: 'العملاء' },
        // pages/crm/Customers/index.js (mảng = OR; custBase = use_Module_AR ? '/crm' : '/sale')
        visible: [
            { whenUserScreen: 'Customers', whenUser: { CRM_update_Customer: 1 } },
            { whenUserScreen: 'Customers', whenUser: { EXROrder_can_create: 1 }, whenSys: { use_Module_EXR: 1, use_Module_AR: { type: '!=', value: 1 } } }
        ],
        open: { module: 'entity', table: 'Customer', navigateLinkBySys: { use_Module_AR: ['/crm/Customer/', '/sale/Customer/'] } }
    },
    {
        key: 'vendor',
        group: 'catalog',
        text: { vi: 'Nhà cung cấp', en: 'Suppliers', fr: 'Fournisseurs', es: 'Proveedores', id: 'Pemasok', ja: '仕入先', zh: '供应商', ko: '공급업체', hi: 'आपूर्तिकर्ता', ar: 'الموردون' },
        // pages/vrm/Vendors/index.js: trang gate theo quyền (render) + nút Thêm
        visible: {
            whenUser: { view_Module_VRM: 1, VRM_update_Vendor: 1 },
            when: {
                grp1: { whenSys: { use_Module_AP: 1, use_Module_EXP: 1 }, whenSysType: 'OR' },
                gr2: { whenSys: { use_Module_VRM: 1 } }
            }
        },
        open: { module: 'entity', table: 'Vendor', navigateLink: '/vrm/Vendor/' }
    }
];

export default accountingQuickCreate;
